<template>
    <app-dialog v-model="isOpen" size="lg">
        <template #header>
            <div class="px-2 pt-1">
                <h3 class="text-lg font-semibold text-theme-base">
                    Nuevo producto
                </h3>
                <p class="text-sm text-theme-muted mt-0.5">
                    Elige cómo quieres crear el producto.
                </p>
            </div>
        </template>

        <div class="flex flex-col sm:flex-row gap-4 px-2 py-4 min-w-96">
            <button
                class="button-card flex-1 bg-brand-blue rounded-xl p-5 shadow-sm text-white flex flex-col items-start"
                @click="goTo('quick')"
            >
                <div class="flex items-start gap-3 mb-3">
                    <span class="text-4xl leading-none">⚡</span>
                    <div class="flex flex-col items-start">
                        <span
                            class="text-xs font-semibold bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-1"
                        >
                            Rápida
                        </span>
                        <h5 class="text-white font-semibold leading-tight">
                            Creación rápida
                        </h5>
                    </div>
                </div>

                <p class="text-sm mb-3 opacity-90">
                    Solo los campos esenciales. Ideal para agregar productos
                    rápido.
                </p>

                <hr class="mb-3 opacity-20" />

                <ul class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90">
                    <li class="flex gap-2">
                        <span class="flex-shrink-0">✅</span>
                        <span>Nombre y precio</span>
                    </li>
                    <li class="flex gap-2">
                        <span class="flex-shrink-0">✅</span>
                        <span>Fotos opcionales</span>
                    </li>
                    <li class="flex gap-2">
                        <span class="flex-shrink-0">⏭</span>
                        <span>Sin variantes ni clasificación</span>
                    </li>
                </ul>

                <div
                    class="mt-4 w-full text-center text-sm font-semibold text-white"
                >
                    Ir a creación rápida →
                </div>
            </button>

            <button
                class="button-card flex-1 bg-brand-purple rounded-xl p-5 shadow-sm text-white flex flex-col items-start"
                @click="goTo('detailed')"
            >
                <div class="flex items-start gap-3 mb-3">
                    <span class="text-4xl leading-none">🛍️</span>
                    <div class="flex flex-col items-start">
                        <span
                            class="text-xs font-semibold bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-1"
                        >
                            Completa
                        </span>
                        <h5 class="text-white font-semibold leading-tight">
                            Creación detallada
                        </h5>
                    </div>
                </div>

                <p class="text-sm mb-3 opacity-90">
                    Wizard paso a paso con toda la configuración del producto.
                </p>

                <hr class="mb-3 opacity-20" />

                <ul class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90">
                    <li class="flex gap-2">
                        <span class="flex-shrink-0">✅</span>
                        <span>Datos básicos y fotos</span>
                    </li>
                    <li class="flex gap-2">
                        <span class="flex-shrink-0">✅</span>
                        <span>Variantes (talla, color, personalizado)</span>
                    </li>
                    <li class="flex gap-2">
                        <span class="flex-shrink-0">✅</span>
                        <span>Categoría, marca e inventario inicial</span>
                    </li>
                </ul>

                <div
                    class="mt-4 w-full text-center text-sm font-semibold text-white"
                >
                    Ir a creación completa →
                </div>
            </button>
        </div>
    </app-dialog>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "ProductCreationModal",
    components: { AppDialog },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    methods: {
        goTo(mode) {
            this.isOpen = false;
            if (mode === "quick") {
                this.$router.push("/app/products/new/fast");
            } else {
                this.$router.push("/app/products/new/complete");
            }
        }
    }
};
</script>
